import { Component, OnInit, Input } from '@angular/core';
import { SetService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { FormControlService } from "ngx-block-core";
import { HttpService } from 'ngx-block-core';
import { selectSize } from "../../../data/data";
@Component({
  selector: 'app-sucu04-weiget0100001',
  templateUrl: './sucu04-weiget0100001.component.html',
  styleUrls: ['./sucu04-weiget0100001.component.css']
})
export class Sucu04Weiget0100001Component implements OnInit {
  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'
  @Input() acl = 'cy';
  @Input() sets = {
    blockCode: "sucublock26",
    blockId: "",
    blockName: "多选框",
    layoutId: "",
    blockType: 'formBlock',
    blockChildType: '',
    versionCode: 4,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    sets: {
      acl: false
    },
    styles: {
      nzMode: 'default',//default|button
      nzButtonStyle: 'solid',//solid|outline
      nzRequired: false,
      nzHasFeedback: true,
      nzReadOnly: false,
      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12
      },
      nzNoSee: false
    },
    datas: {
      nzDynamicData: false,
      nzDynamicSearch: {
        //select test001_id as value,test001_name as label ,'false' as checked  from t_test001 where test001_id<5
        nzDynamicSql: "select columnA as value,columnB as label from tableNmae where ...",
      },
      nzData: [{ value: '1', label: '男' }, { value: '2', label: '女' }],
    }
  };

  setData = []
  nzData = []
  constructor(
    public setService: SetService,
    private http: HttpService,
    public formControlService: FormControlService
  ) { }
  ngOnInit() {
    this.baseInit();
    this.nzData = JSON.parse(JSON.stringify(this.sets.datas.nzData));

    this.autoUpdate();
  }
  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 3) {

      this.sets.blockCode = "sucublock26";

      this.sets.versionCode = 3;
    }
    //v4,升级自定义表单参数
    if (this.sets.versionCode < 4) {
      if (typeof this.sets.styles.nzNoSee == "undefined")
        this.sets.styles.nzNoSee = false;
      this.sets.versionCode = 4;
    }

  }
  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' },
              {
                name: 'nzFormSearchType', inputs: {
                  nzData: [{ value: 'in', label: 'in' }]
                }
              },
              {
                name: 'nzDynamicSearch', inputs: {
                  nzNeedPage: false, nzOptions: [{
                    name: 'checked',
                    type: 'boolean',
                    value: false
                  }]
                }
              },
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] }
              },
              {
                name: 'nzLayout'
              },
              {
                name: 'switch',
                inputs: { nzText: "显示必填* : ", nzKeys: ['styles', 'nzRequired'], nzPopContent: ['仅影响样式'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "校验图标 : ", nzKeys: ['styles', 'nzHasFeedback'], nzPopContent: ['校验状态的图标'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "checkboxJsonArray";
                  }
                }
              },
            ]
          }

        ]
      },
      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      }
    ]
  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.nzFormGroupData['nzSearchDataType'] = "checkboxJsonArray";
        if (this.sets.styles.nzNoSee == true)
          this.nzFormGroupData['nzSearchDataType'] = "noSee";
        if (this.nzFormGroupData['nzSearchType'] == 'null')
          this.nzFormGroupData['nzSearchType'] = "in";
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()
      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
    if (this.sets.datas.nzDynamicData) {
      this.sets.datas.nzData = [];
      this.initSelected();
    }
    this.Listening();
  }
  ngOnDestroy() {
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
  }
  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        switch (data['type']) {
          case 'changeFormValid':
            this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
            break;
          case 'refresh':
            this.initSelected();
            break;


          default:
            break;
        }
      }
      )
    }, 100);

  }
  Listening() {
    console.log("Listening", this.blockid)
    setTimeout(() => {
      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        data => {
          console.log("data", JSON.stringify(data))
          switch (data['type']) {
            case 'reset':
              if (this.sets.datas.nzDynamicData) {
                this.sets.datas.nzData = [];
                this.initSelected();
              } else {
                this.sets.datas.nzData = JSON.parse(JSON.stringify(this.nzData));
              }
              break;

            default:
              break;
          }


        }
      )
    }, !this.static ? 100 : 0);


  }
  initSelected() {
    let body = {
      "dynamicSql": this.sets.datas.nzDynamicSearch.nzDynamicSql,
      "pageSize": 100,
      "nowPage": 1,
      "paramMap": [
      ],
      "tableSort": [],
      "searchMap": {}
    }
    this.http.postHttp("/system/dynamicSql", body).subscribe(
      (data: any) => {
        this.sets.datas.nzData = [...data.data.list];
      });
  }

}
